import React from 'react';
import { Container} from '@mui/material';
import Header from '../components/layout/Header';
import DonInstitutionForm from '../components/forms/DonInstitutionForm';

const DonInstitutions = () => {
  
  return (
    <>
      <Header />
      <Container maxWidth="md" sx={{ mt: {xs: 2, md :0}, px: { xs: 1, sm: 2 } }}>
        <DonInstitutionForm />
      </Container>
    </>
  );
};

export default DonInstitutions;